import React from 'react'
import AboutSection from '../components/AboutSection'

const About = () => {
  return (
    <div>
        <AboutSection isFullPage = {true}/>
    </div>
  )
}

export default About